import {
  CompassCardComponent,
  CompassCardComponentProps,
} from 'react-scale/corp/views/DataCompassV2/types';
import useJoinContributorDataCard from './useJoinContributorDataCard';
// import { DataCompassUtils } from 'react-scale/corp/views/DataCompassV2/dataCompassUtils';
// import { useCompassCard } from '@scale/compass-ui/store';
import { Flex, FormField, Select, Box } from '@scale/scaleui-radix';
const JoinContributorDataCardComponent: CompassCardComponent = ({
  index,
}: CompassCardComponentProps) => {
  const { contributorIdsColumnName, setContributorIdsColumnName } =
    useJoinContributorDataCard(index);
  // const { card } = useCompassCard(index);

  return (
    <Flex gap="2" direction="column">
      <div>// TODO fix to use column metadata instead of frontend inference</div>
      <Box maxWidth="400px">
        <FormField.Root size="3">
          <FormField.Label htmlFor="contributor-id-select">Contributor IDs Column</FormField.Label>
          <Select.Root
            value={contributorIdsColumnName ?? ''}
            onValueChange={setContributorIdsColumnName}
          >
            <Select.Trigger id="contributor-id-select" placeholder="Select a column..." />
            <Select.Content>
              {/* {(DataCompassUtils.mongoIdColumns(card) ?? []).map(column => (
                <Select.Item key={column.id ?? '-'} value={column.header ?? '-'}>
                  {column.header ?? '-'}
                </Select.Item>
              ))} */}
            </Select.Content>
          </Select.Root>
        </FormField.Root>
      </Box>
    </Flex>
  );
};

export default JoinContributorDataCardComponent;
